import ApiClient from './ApiClient';

class CustomModulesAPI extends ApiClient {
  constructor() {
    super('custom_modules', { accountScoped: true });
  }
}

export default new CustomModulesAPI();
